// extracted by mini-css-extract-plugin
export default {"customIcon":"IOtda","icon":"wjCqh","customIconButton":"a_OXL","iconButton":"KdShc"};